import styled from '@emotion/styled';
import {Typography} from '@mui/material';
import {APP} from 'src/styles/variables';

export const DialogWrapperDiv = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  height: 100%;
`;

export const TextContent = styled(Typography)`
  font-size: 1rem !important;
  font-weight: 100 !important;
  color: ${APP.PALETTE.SUB_MODULE_COLOR.BLACK} !important;
`;
